import { render } from "./app-logo-m1pay.vue?vue&type=template&id=5cb8ad9e"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-m1pay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cb8ad9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cb8ad9e', __exports__)) {
    console.log('reload')
    api.reload('5cb8ad9e', __exports__)
  }
  
  module.hot.accept("./app-logo-m1pay.vue?vue&type=template&id=5cb8ad9e", () => {
    console.log('re-render')
    api.rerender('5cb8ad9e', render)
  })

}


export default __exports__